import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { AuthService } from 'src/app/seguranca/auth.service';
import { environment } from 'src/environments/environment';
import { SubMenuComponent } from '../sub-menu/sub-menu.component';
import { criarMenu } from './menu';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  standalone: true,
  imports: [SubMenuComponent],
})
export class MenuComponent implements OnInit, OnDestroy {
  private readonly auth = inject(AuthService);
  private readonly router = inject(Router);

  @Input() reset = false;

  @Output() moveBar = new EventEmitter();

  menuItens: MenuItem[] = [];

  activeUrl: string = '';

  private routerSubscription?: Subscription;

  controlaAssinatura = environment.controlaAssinatura;

  ngOnInit() {
    this.menuItens =
      this.controlaAssinatura && this.auth.havePermission('ROLE_INADIPLENTE')
        ? [{ label: 'Dashboard', icon: 'pi pi-chart-line', routerLink: ['/'] }]
        : criarMenu(this.auth.jwtPayload?.authorities ?? []);

    this.activeUrl = this.router.url;
    this.routerSubscription = this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe((e) => {
        this.activeUrl = e.urlAfterRedirects ?? e.url;
      });
  }

  ngOnDestroy() {
    this.routerSubscription?.unsubscribe();
  }

  changeTheme(theme: string) {
    const themeLink: HTMLLinkElement = <HTMLLinkElement>(
      document.getElementById('theme-css')
    );
    const layoutLink: HTMLLinkElement = <HTMLLinkElement>(
      document.getElementById('layout-css')
    );

    themeLink.href = `assets/theme/theme-${theme}.css`;
    layoutLink.href = `assets/layout/css/layout-${theme}.css`;
  }
}
